import React, { useState, useMemo } from "react";
import { Bar } from "react-chartjs-2";

const BarChart = ({ graphData = [] }) => {
  const [colorMap, setColorMap] = useState({});
  const [selectedColors, setSelectedColors] = useState({});

  const generateColor = () => {
    return "#" + Math.random().toString(16).substr(-6);
  };

  const newColorFind = (id) => {
    if (colorMap[id]) return colorMap[id];

    let newColor;
    do {
      newColor = generateColor();
    } while (selectedColors[newColor]);

    setColorMap((prev) => ({ ...prev, [id]: newColor }));
    setSelectedColors((prev) => ({ ...prev, [newColor]: true }));

    return newColor;
  };

  // ✅ Use useMemo to avoid recalculating on every render
  const { labels, datasets } = useMemo(() => {
    if (!graphData || graphData.length === 0) {
      return { labels: [], datasets: [] };
    }

    const firstItem = graphData[0];
    const labels = [...(firstItem?.label || [])]; // clone array safely

    const datasets = graphData.map((item, key) => {
      const clr = newColorFind(key);
      return {
        label: item?.type,
        backgroundColor: clr,
        borderColor: clr,
        borderWidth: 1,
        hoverBackgroundColor: "rgba(255,99,132,0.4)",
        hoverBorderColor: "rgba(255,99,132,1)",
        data: [...(item?.data || [])], // clone data array
      };
    });

    return { labels, datasets };
  }, [graphData]);

  const data = { labels, datasets };

  return (
    <div className="chart">
      <Bar
        data={data}
        width={100}
        height={50}
        options={{ maintainAspectRatio: false }}
      />
    </div>
  );
};

export default BarChart;
